import {
  FACETED_SEARCH_QUERY,
  ADVANCED_SEARCH_REAR_DIMENSION_QUERY,
} from '../constants';

export const historyMiddleware = (store) => (next) => (action) => {
  const { type, payload } = action;
  switch (type) {
    case FACETED_SEARCH_QUERY:
      let { query } = payload;
      const url =
        window.location.href.replace(window.location.search, '') +
        `${query && !window.location.href.endsWith('?') ? '?' : ''}${query}`;
      window.history.pushState('search', 'Search Page', url);
      break;
    case ADVANCED_SEARCH_REAR_DIMENSION_QUERY:
      const { dimensions } = payload;

      const newUrl = new URL(window.location);

      if (!!dimensions.rearWidth) {
        newUrl.searchParams.set('rearWidth', dimensions.rearWidth);
      } else {
        newUrl.searchParams.delete('rearWidth');
      }

      if (!!dimensions.rearProfile) {
        newUrl.searchParams.set('rearProfile', dimensions.rearProfile);
      } else {
        newUrl.searchParams.delete('rearProfile');
      }

      if (!!dimensions.rearRimDiameter) {
        newUrl.searchParams.set('rearRimDiameter', dimensions.rearRimDiameter);
      } else {
        newUrl.searchParams.delete('rearRimDiameter');
      }

      window.history.pushState('search', 'Search Page', newUrl.toString());

      break;
  }
  next(action);
};
